/**
 * Created by mady on 31-08-2016.
 * Note. DEPRECATED. Use the Data hierarchy spot variation named data-list-search
 */
/**
 * Created by mady on 12-07-2016.
 * Note. DEPRECATED. Use the Data hierarchy spot variation named data-list-search
 */

(function ($, DGS) {
  var DataListSearchSpot = DGS.DataListSearchSpot || {};
  DataListSearchSpot.getConfigForDataListSearchSpot = function ($dataListSearchSpot) {
    var configId = $dataListSearchSpot.data("configuration"),
      configText = $("script[data-configuration=" + configId + "]").html();
    try {
      return JSON.parse(configText);
    } catch (error) {
      return {};
    }
  };
  DGS.OnLoad.getInstance().register(function () {
    $("#wrapper > #content .component.data-list-search-spot").each(function () {
      var $dataListSearchSpot = $(this),
        blockSearchTemp = false,
        config = DataListSearchSpot.getConfigForDataListSearchSpot($dataListSearchSpot),
        $advSearchToggle = $('.data-list-search-spot__adv-search-toggle'),
        $advSearchContainer = $('.data-list-search-spot__adv-search-outer-container'),
        querySearch = DGS.getLocationHash().toLowerCase(),
        setBlockSearchTemp = function setBlockSearchTemp() {
          blockSearchTemp = true;
          setTimeout(function () {
            blockSearchTemp = false;
          }, 500);
        },
        basicSearchTerm = function (querySearch) {
          return querySearch.indexOf(':') == -1 ? querySearch : null;
        }(querySearch),
        advSearchFields = function (querySearch) {
          if (querySearch.indexOf(':') > -1) {
            var searchParts = querySearch.split('/'),
              searchObj = {},
              keyValue,
              key,
              value;
            searchParts.forEach(function (searchPart) {
              keyValue = searchPart.split(':');
              key = keyValue[0];
              value = keyValue[1];
              if (!searchObj.hasOwnProperty(key)) {
                searchObj[key] = [];
              }
              searchObj[key].push(value);
            });
            return searchObj;
          }
          return null;
        }(querySearch),
        openAdvSearch = function openAdvSearch() {
          $advSearchToggle.addClass('open');
          $advSearchContainer.addClass('open');
          $('.data-list-search-spot__query', $dataListSearchSpot).prop('disabled', true);
          var position = $('.data-list-search-spot__adv-search-outer-container').position(),
            top = position ? position.top : null;
          if (top != null) {
            //window.scrollTo(0, );
            TweenMax.to(window, 0.3, {
              scrollTo: {
                x: 0,
                y: top - 6 * parseFloat(getComputedStyle(document.body).fontSize)
              }
            });
          }
        },
        closeAdvSearch = function closeAdvSearch() {
          $advSearchToggle.removeClass('open');
          $advSearchContainer.removeClass('open');
          $('.data-list-search-spot__query', $dataListSearchSpot).prop('disabled', false);
        };

      // TOGGLE ADV / SIMPLE SEARCH
      $advSearchToggle.click(function () {
        var $this = $(this);
        if (!$this.hasClass('open')) {
          openAdvSearch();
        } else {
          closeAdvSearch();
        }
      });

      // FREE SEARCH QUERY
      $('.data-list-search-spot__query', $dataListSearchSpot).keyup(function (e) {
        if (blockSearchTemp) return;
        if (e.keyCode == 13) {
          setBlockSearchTemp();
          DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_REQUEST_BUILD_QUERY, $dataListSearchSpot, config.endpoint);
        }
      });

      // ADV SEARCH
      $('.data-list-search-spot__adv-search-input', $dataListSearchSpot).keyup(function (e) {
        if (blockSearchTemp) return;
        if (e.keyCode == 13) {
          setBlockSearchTemp();
          DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_REQUEST_BUILD_ADV_QUERY, $dataListSearchSpot, config.endpoint);
        }
      });
      $('.data-list-search-spot__adv-search-btn-container a', $dataListSearchSpot).click(function (event) {
        if (blockSearchTemp) return;
        event.preventDefault();
        setBlockSearchTemp();
        DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_REQUEST_BUILD_ADV_QUERY, $dataListSearchSpot, config.endpoint);
      });

      // BUILD SELECT GROUP
      $('.data-list-search-spot__adv-search-select-group', $dataListSearchSpot).each(function () {
        var allLabel = "All",
          allContent = [allLabel],
          $this = $(this),
          $selects = $('.custom-select-container', $this),
          level1Endpoint = "/webservices/assortment.svc/getcategories",
          level2Endpoint = "/webservices/assortment.svc/getmodels",
          level3Endpoint = "/webservices/assortment.svc/getstyles",
          $level1Select = $($selects[0]),
          $level2Select = $($selects[1]),
          $level3Select = $($selects[2]),
          getContent = function getContent(endpoint, callback) {
            $.ajax({
              url: endpoint,
              type: 'GET'
            }).then(function (data, textState, jqXHR) {
              callback.apply(null, [data]);
            }, function (jqXHR, textStatus, msg) {
              callback.apply(null, [[]]); // returning empty array on error
            });
          },
          resetControl = function resetControl() {
            $level2Select.customSelectOptions(allContent);
            $level2Select.customSelectSetValue(0);
            $level2Select.customSelectDisabled(true);
            $level3Select.customSelectOptions(allContent);
            $level3Select.customSelectSetValue(0);
            $level3Select.customSelectDisabled(true);
          };
        var populateLevel1 = function populateLevel1() {
            getContent(level1Endpoint, function (content) {
              $level1Select.customSelectOptions(allContent.concat(content));
              $level1Select.customSelectSetValue(0);
            });
          },
          populateLevel2 = function populateLevel2(level1) {
            getContent(level2Endpoint + "/" + level1, function (content) {
              $level2Select.customSelectOptions(content);
              $level2Select.customSelectSetValue(0);
            });
          },
          populateLevel3 = function populateLevel3(level1, level2) {
            getContent(level3Endpoint + "/" + level1 + "/" + level2, function (content) {
              $level3Select.customSelectOptions(content);
              $level3Select.customSelectSetValue(0);
            });
          };
        $level1Select.customSelectChange(function () {
          var levelValue = $level1Select.customSelectGetValue();
          if (levelValue == allLabel) {
            resetControl();
            return;
          }
          populateLevel2(levelValue);
          $level2Select.customSelectDisabled(false);
        });
        $level2Select.customSelectChange(function () {
          populateLevel3($level1Select.customSelectGetValue(), $level2Select.customSelectGetValue());
          $level3Select.customSelectDisabled(false);
        });
        populateLevel1();
        resetControl();
      });

      // HANDLE URL QUERY STRING SEARCH
      if (basicSearchTerm) {
        $('.data-list-search-spot__query', $dataListSearchSpot).val(basicSearchTerm);
        DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_REQUEST_INITIAL_BUILD_QUERY, $dataListSearchSpot, config.endpoint);
      } else if (advSearchFields) {
        openAdvSearch();
        $('*[class*=field]').each(function () {
          var $input = $(this);
          var classes = $input.attr('class').toLowerCase().split(' '),
            value;
          classes.forEach(function (className) {
            if (className.indexOf('field-') == 0) {
              className = className.substr(6);
              if (advSearchFields.hasOwnProperty(className)) {
                value = advSearchFields[className].shift();
                if (advSearchFields[className].length == 0) {
                  delete advSearchFields[className];
                }
                $input.val(value);
              }
            }
          });
        });
        DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_REQUEST_INITIAL_BUILD_ADV_QUERY, $dataListSearchSpot, config.endpoint);
      }
    });
  });
  DGS.DataListSearchSpot = DataListSearchSpot;
})(jQuery, window.DGS);
(function ($, DGS, moment) {
  var createQueryForIndex = function createQueryForIndex(field, query) {
    return field + ":" + query.trim() + "*";
  };
  DGS.Event.getInstance().on(DGS.DataListSpotConfig.Event.DATA_REQUEST_BUILD_QUERY, function ($dataListSearchSpot, endpoint) {
    $("#wrapper > #content .component.data-list-search-spot").each(function () {
      var $this = $(this),
        config = DGS.DataListSearchSpot.getConfigForDataListSearchSpot($this),
        $queryField = $('.data-list-search-spot__query', $dataListSearchSpot),
        queryString = $queryField.val(),
        dateFormatString = config.dateFormat ? config.dateFormat.toUpperCase() : "YYYY-MM-DD",
        dateMoment = moment.utc(queryString, dateFormatString, true),
        queryDate = dateMoment.isValid() ? dateMoment.toDate() : null,
        textSearch = queryDate === null ? 'text=' + queryString.trim() + '*' : null;
      if (queryDate) {
        DGS.setLocationHash('date:' + moment(queryDate).format('YYYYMMDD') + "-" + moment(queryDate).format('YYYYMMDD'));
      } else {
        DGS.setLocationHash(queryString);
      }
      if (config.endpoint == endpoint) {
        DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, queryDate, queryDate, {}, 'or', textSearch);
      }
    });
  });
  DGS.Event.getInstance().on(DGS.DataListSpotConfig.Event.DATA_REQUEST_BUILD_ADV_QUERY, function ($dataListSearchSpot, endpoint) {
    $("#wrapper > #content .component.data-list-search-spot").each(function () {
      var $this = $(this),
        config = DGS.DataListSearchSpot.getConfigForDataListSearchSpot($this),
        filterObject = {},
        datePicker = $('.date-list-search-spot--date-picker', $this),
        datePickerName = datePicker.attr('name'),
        fromDate = datePicker.customDatePickerFrom(),
        toDate = datePicker.customDatePickerTo(),
        c = 0,
        searchHashes = [];
      if (config.endpoint == endpoint) {
        //RUN THROUGH ALL data-list-search-spot__adv-search-input
        // ADD VALUE TO FILTER IF VALUE IS NOT EMPTY
        $('.data-list-search-spot__adv-search-input', $this).each(function () {
          var $this = $(this),
            re = /(field-[a-zA-Z]+)/,
            m,
            field,
            value = $this.val().trim();
          if ((m = re.exec($this.prop('class'))) !== null) {
            if (m.index === re.lastIndex) {
              re.lastIndex++;
            }
            field = m[0].substr(6);
          }
          if (field && value != '' && (field != 'categories' || value != 'All') && (field != 'models' || value != 'All') && (field != 'styles' || value != 'All')) {
            filterObject[field + ++c] = createQueryForIndex(field, value);
            searchHashes.push(field + ':' + value);
          }
        });
        DGS.setLocationHash(searchHashes.join('/'));
        DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', "text=" + Object.keys(filterObject).map(function (f) {
          return filterObject[f];
        }).join(" AND "));
      }
    });
  });
  DGS.OnLoad.getInstance().register(function () {
    $("#wrapper > #content .component.data-list-search-spot").each(function () {
      var $this = $(this),
        config = DGS.DataListSearchSpot.getConfigForDataListSearchSpot($this),
        querySearch = DGS.getLocationHash().toLowerCase(),
        querySearchFrom = null,
        querySearchTo = null,
        advSearchFields = function (querySearch) {
          if (querySearch.indexOf(':') > -1) {
            var searchParts = querySearch.split('/'),
              searchObj = {},
              keyValue,
              key,
              value;
            searchParts.forEach(function (searchPart) {
              keyValue = searchPart.split(':');
              key = keyValue[0];
              value = keyValue[1];
              if (!searchObj.hasOwnProperty(key)) {
                searchObj[key] = [];
              }
              searchObj[key].push(value);
            });
            return searchObj;
          }
          return null;
        }(querySearch);

      // HANDLE URL QUERY STRING SEARCH
      if (advSearchFields) {
        if (advSearchFields.hasOwnProperty('date')) {
          var dateRange = advSearchFields.date[0].split('-');
          querySearchFrom = dateRange[0];
          querySearchTo = dateRange[1];
        }
      }
      config.shortcuts = config.shortcuts != undefined || config.shortcuts != null ? eval(config.shortcuts) : config.shortcuts;
      $('.date-list-search-spot--date-picker', $this).customDatePicker({
        shortcuts: config.shortcuts || [{
          label: "Last 7 days",
          expr: "-7d"
        }, {
          label: "Last 30 days",
          expr: "-30d"
        }, {
          label: "Last Month",
          expr: "-1mo"
        }],
        initialFrom: querySearchFrom,
        initialTo: querySearchTo,
        expr: config.expr || "-60d",
        dateRangeLimit: config.dateRangeLimit || "60d",
        dateFormat: config.dateFormat ? config.dateFormat.toUpperCase() : "YYYY-MM-DD",
        customRangeLabel: config.customRangeLabel || "Custom range",
        fromDateLabel: config.fromDateLabel || "FROM",
        toDateLabel: config.toDateLabel || "TO",
        applyLabel: config.applyLabel || "Apply",
        cancelLabel: config.cancelLabel || "Cancel",
        negativeRangeLabel: config.negativeRangeLabel || "FROM must be before TO",
        invalidRangeLabel: config.invalidRangeLabel || "FROM and TO cannot be more than 60 days apart"
      });
      if ($this.hasClass('payment-search-spot')) {
        $('.date-list-search-spot--date-picker', $this).change(function () {
          DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_REQUEST_BUILD_ADV_QUERY, $this, config.endpoint);
        });
      }
      $('.help', $this).each(function () {
        var $this = $(this),
          $content = $('.help-content', $this.parent()),
          $overlay = $('.help-content-overlay', $this.parent()),
          $contentButton = $('.help-content-button', $content);
        $.merge($this, $contentButton).click(function () {
          if (!$overlay.length) {
            $overlay = $('<div class="help-content-overlay"></div>');
            $content.before($overlay);
          }
          if (!$content.is(':visible')) {
            $overlay.show();
            $content.show();
            TweenMax.fromTo($content, .3, {
              alpha: 0
            }, {
              alpha: 1,
              ease: Power2.easeIn
            });
          } else {
            TweenMax.fromTo($content, .3, {
              alpha: 1
            }, {
              alpha: 0,
              ease: Power2.easeIn,
              onComplete: function onComplete() {
                $content.hide();
                $overlay.hide();
              }
            });
          }
        });
      });
    });
    $('#wrapper > #content .component.order-list-spot.data-list-search-spot.order-list-search-remove-date-picker').each(function () {
      var $this = $(this),
        $columns = $('.data-list-search-spot__adv-search-column', $this),
        $button = $('.data-list-search-spot__adv-search-btn-container', $this);
      $($columns[1]).append($button);
      $($columns[2]).remove();
      $this.removeClass('three-columns');
      $this.addClass('two-columns');
    });
  });
})(jQuery, window.DGS, window.moment);